import { createContext, useContext, useMemo, useReducer, type ReactNode } from 'react'
import { appReducer, initialAppState, type AppAction, type AppState } from './types'

interface AppStore {
  state: AppState
  dispatch: React.Dispatch<AppAction>
}

const AppStateContext = createContext<AppStore | null>(null)

export function AppStateProvider({ children }: { children: ReactNode }) {
  const [state, dispatch] = useReducer(appReducer, initialAppState)
  const value = useMemo<AppStore>(() => ({ state, dispatch }), [state])
  return <AppStateContext.Provider value={value}>{children}</AppStateContext.Provider>
}

export function useAppState(): AppStore {
  const ctx = useContext(AppStateContext)
  if (!ctx) {
    throw new Error('useAppState must be used within <AppStateProvider>')
  }
  return ctx
}
